import LogisticsPageHero from '../Logistics/LogisticsPageHero';

const INTEGRATIONS_HERO_IMG =
  '/integrations/INTEGRATIONS_HERO_IMG.jpg';

const IntegrationsHero = () => (
  <LogisticsPageHero
    ariaLabel="E-commerce and marketplace integrations"
    imageSrc={INTEGRATIONS_HERO_IMG}
    imageAlt="Sales channels and marketplace integrations for UK fulfilment"
    titleLight="650+ Integrations"
    titleAccent="to Connect Your Entire Ecommerce Business"
    description={
      <>
        <p>
         Connect your online stores, marketplaces, courier services and back-office systems through one powerful UK fulfilment centre. Our integrated Warehouse Management System (WMS) automatically synchronises orders, inventory, shipping and tracking across every sales channel, helping you reduce manual work, improve order accuracy and scale your eCommerce fulfilment with confidence.
        </p>
        <p>Integrate with 650+ leading platforms, including:</p>
      </>
    }
    features={[
      'Amazon & Seller Central & Amazon FBA ',
      'Shopify & Shopify Plus',
      '	eBay, TikTok Shop & Etsy ',
      'WooCommerce, ERP & Accounting Systems ',
      'Royal Mail, DPD, DHL, UPS & Custom APIs',
    ]}
    primaryCta={{ label: 'Discuss your stack', to: '/contact-fulfillment-services' }}
    secondaryCta={{ label: 'WMS integrations', to: '/wms-integrations' }}
  />
);

export default IntegrationsHero;
